import React from 'react';
import Clamp from 'react-multiline-clamp';
import Flickity from 'react-flickity-component';
import { hasIn, map, filter, get } from 'lodash';
import common from '../../../common/common';
import { generateCmsUrl } from '../../../services/cms/cmsService';
import './TopBlogPosts.scss';

function TopBlogPosts({ blogposts, showInCarousel }) {
    const flickityOptions = {
        autoPlay: false,
        cellAlign: 'left',
        contain: true,
        draggable: false,
        groupCells: true,
        initialIndex: 0,
        lazyLoad: false,
        pageDots: false,
        prevNextButtons: true,
        resize: true,
        wrapAround: false,
    };

    const renderedItems = map(
        filter(blogposts, (bp) => {
            return hasIn(
                bp,
                'attributes.mainCreativeWork.mainImage.data.attributes.url'
            );
        }),
        (ci, idx) => {
            const currentItem = ci.attributes;
            const mainCreativeWork = currentItem.mainCreativeWork;
            const imageUrl = generateCmsUrl(
                get(currentItem, 'mainImage.data.attributes.url')
            );

            return (
                <div
                    key={ci.id}
                    className={
                        idx === 0
                            ? 'top-blogposts-item-container first'
                            : idx === blogposts.length - 1
                            ? 'top-blogposts-item-container last'
                            : 'top-blogposts-item-container'
                    }>
                    <a href={`${common.getSiteUrl()}/news/${currentItem.slug}`}>
                        <div className='blogpost-info-container'>
                            <div>
                                <h2>{mainCreativeWork.headline}</h2>

                                <Clamp lines={2}>
                                    <p className='alternative-headline'>
                                        {mainCreativeWork.alternativeHeadline}
                                    </p>
                                </Clamp>
                            </div>
                            <span className='blogpost-info'>
                                <small> {mainCreativeWork.author}</small>
                                &nbsp;|&nbsp;
                                <small className='published-date'>
                                    {new Date(
                                        mainCreativeWork.datePublished
                                    ).toLocaleDateString()}
                                </small>
                            </span>
                        </div>
                        <div className='image-container'>
                            <div className='image-wrapper'>
                                <picture>
                                    <source srcSet={imageUrl} />
                                    <img
                                        className='animated-image'
                                        itemProp='image'
                                        src={imageUrl}
                                    />
                                </picture>
                            </div>
                        </div>
                    </a>
                </div>
            );
        }
    );

    const renderedItemsCarousel = map(blogposts, (ci, idx) => {
        const currentItem = ci.attributes;
        const mainCreativeWork = currentItem.mainCreativeWork;
        const imageUrl = generateCmsUrl(
            get(currentItem, 'mainImage.data.attributes.url')
        );
        return (
            <div key={idx} className='carousel-cell'>
                <a href={`${common.getSiteUrl()}/news/${currentItem.slug}`}>
                    <div className='blogpost-headline'>
                        <div>
                            <h2>{mainCreativeWork.headline}</h2>

                            <Clamp lines={2}>
                                <p className='alternative-headline'>
                                    {mainCreativeWork.alternativeHeadline}
                                </p>
                            </Clamp>
                        </div>
                        <span className='blogpost-info'>
                            <small> {mainCreativeWork.author}</small>
                            &nbsp;|&nbsp;
                            <small className='published-date'>
                                {new Date(
                                    mainCreativeWork.datePublished
                                ).toLocaleDateString()}
                            </small>
                        </span>
                    </div>
                    <div className='image-container'>
                        <div className='image-wrapper'>
                            <picture>
                                <source srcSet={imageUrl} />
                                <img
                                    className='animated-image'
                                    itemProp='image'
                                    src={imageUrl}
                                />
                            </picture>
                        </div>
                    </div>
                </a>
            </div>
        );
    });
    if (blogposts && blogposts.length === 1)
        return (
            <div className='top-blogposts'>
                <div className='top-blogposts-carousel-container top-blogposts-carousel-container-flex'>
                    {renderedItems}
                </div>
            </div>
        );
    if (blogposts && blogposts.length > 1)
        return showInCarousel ? (
            <div className='top-blogposts'>
                <div className='top-blogposts-carousel-container'>
                    <Flickity options={flickityOptions}>
                        {renderedItemsCarousel}
                    </Flickity>
                </div>
            </div>
        ) : (
            <div className='top-blogposts'>
                <div className='top-blogposts-carousel-container top-blogposts-carousel-container-flex'>
                    {renderedItems}
                </div>
            </div>
        );
    return <></>;
}
export default TopBlogPosts;
